import { useState, useContext } from 'react';
import Layout from '../components/Layout';
import ContextStates from '../context/ContextStates';
import ListadoRepartos from '../components/admin/listadoRepartos';
import FViewRepUsr from '../components/admin/fViewRepUsr';

const Repartos = () => {
	const [tab, setTab] = useState(0)
	const { roles } = useContext(ContextStates)

	return (
		<Layout
			pagina={"Repartos"}
		>
			{(roles.includes("1")) ? (
				<div className='w-full p-5 min-h-full'>
					<ListadoRepartos />
				</div>
			) : (
				<FViewRepUsr />
			)}
		</Layout>
	)
}

export default Repartos